<router-outlet></router-outlet>

<div bsModal #sessionExpirationModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="SessionExpiringModal"
     aria-hidden="true">
    <div class="modal-dialog modal-danger" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Session Expiration</h4>
                <button type="button" class="close" (click)="sessionExpirationModal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{idleState}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="sessionExpirationModal.hide()">Cancel</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>